import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { AnalyticsProvider } from './contexts/AnalyticsContext'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <AnalyticsProvider>
          <SubscriptionProvider>
            <App />
          </SubscriptionProvider>
        </AnalyticsProvider>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
)
